import React from 'react';
import Chip from '@material-ui/core/Chip';

const statusColors = {
    // Contract status
    1: { label: 'Solicitado', bg: '#90caf9', color: '#0d47a1' },
    2: { label: 'Vigente', bg: '#a5d6a7', color: '#1b5e20' },
    3: { label: 'Encerrado', bg: '#e0e0e0', color: '#616161' },
    4: { label: 'Cancelado', bg: '#e0e0e0', color: '#424242' },
    5: { label: 'Em Trial', bg: '#90caf9', color: '#0d47a1' },
    6: { label: 'Suspenso', bg: '#ffcc80', color: '#e65100' },
    7: { label: 'Expirado', bg: '#ef9a9a', color: '#b71c1c' },
    8: { label: 'Inadimplente', bg: '#ef9a9a', color: '#b71c1c' },
    9: { label: 'Desprovisionado', bg: '#616161', color: '#fafafa' },
};

const subscriptionStatusColors = {
    'active': { label: 'Ativo', bg: '#a5d6a7', color: '#1b5e20' },
    'trialing': { label: 'Trial', bg: '#90caf9', color: '#0d47a1' },
    'past_due': { label: 'Inadimplente', bg: '#ef9a9a', color: '#b71c1c' },
    'canceled': { label: 'Cancelado', bg: '#e0e0e0', color: '#424242' },
    'paused': { label: 'Suspenso', bg: '#ffcc80', color: '#e65100' },
    'incomplete': { label: 'Incompleto', bg: '#fff9c4', color: '#f57f17' },
};

const provisioningStatusColors = {
    'pending': { label: 'Pendente', bg: '#fff9c4', color: '#f57f17' },
    'processing': { label: 'Processando', bg: '#90caf9', color: '#0d47a1' },
    'completed': { label: 'Concluído', bg: '#a5d6a7', color: '#1b5e20' },
    'failed': { label: 'Falhou', bg: '#ef9a9a', color: '#b71c1c' },
    'partial': { label: 'Parcial', bg: '#ffcc80', color: '#e65100' },
    'rolling_back': { label: 'Revertendo', bg: '#ffcc80', color: '#e65100' },
    'deprovisioning': { label: 'Desprovisionando', bg: '#ce93d8', color: '#4a148c' },
    'deprovisioned': { label: 'Desprovisionado', bg: '#e0e0e0', color: '#424242' },
    'deprovision_failed': { label: 'Falha no Desprovision.', bg: '#ef9a9a', color: '#b71c1c' },
};

const paymentStatusColors = {
    1: { label: 'Pago', bg: '#a5d6a7', color: '#1b5e20' },
    2: { label: 'Falhou', bg: '#ef9a9a', color: '#b71c1c' },
};

export function ContractStatusBadge({ statusId }) {
    const status = statusColors[statusId] || { label: `Status ${statusId}`, bg: '#e0e0e0', color: '#424242' };
    return <Chip size="small" label={status.label} style={{ backgroundColor: status.bg, color: status.color, fontWeight: 500 }} />;
}

export function SubscriptionStatusBadge({ status }) {
    const s = subscriptionStatusColors[status] || { label: status || '-', bg: '#e0e0e0', color: '#424242' };
    return <Chip size="small" label={s.label} style={{ backgroundColor: s.bg, color: s.color, fontWeight: 500 }} />;
}

export function ProvisioningStatusBadge({ status }) {
    const s = provisioningStatusColors[status] || { label: status || '-', bg: '#e0e0e0', color: '#424242' };
    return <Chip size="small" label={s.label} style={{ backgroundColor: s.bg, color: s.color, fontWeight: 500 }} />;
}

export function PaymentStatusBadge({ statusId }) {
    const s = paymentStatusColors[statusId] || { label: `Status ${statusId}`, bg: '#e0e0e0', color: '#424242' };
    return <Chip size="small" label={s.label} style={{ backgroundColor: s.bg, color: s.color, fontWeight: 500 }} />;
}

export default ContractStatusBadge;
